/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect } from "react";

import { IoClose } from "react-icons/io5";
import * as Off from "./styles";

export const OffCanvasAnimations = {
  Vertical: 'verticalAnimation',
  Horizontal: 'horizontalAnimation',
};

export function OffCanvas({
  title = "Default Title",
  titleIcon,
  subtitle = "",
  expanded = false,
  id = "offCanvas",
  onClose,
  clearValues,
  backgroundColor,
  width,
  isModal = false,
  children,
  colorCloseIcon,
  backgroundCloseIconColor,
  sizeCloseText,
  colorCloseText,
  colorTitle,
  fontSizeTitle,
  typeAnimation = OffCanvasAnimations.Vertical,
  footer,
  headerItem,
  paddingBody,
}) {
  const [isExpanded, setIsExpanded] = useState(expanded);

  const handleClose = () => {
    if (onClose) onClose();
  };

  const closeIfClickEmpty = (event) => {
    const clickedElement = event.target;

    if (!clickedElement.closest(`.${id}`)) {
      handleClose();
    }
  };

  useEffect(() => {
    setIsExpanded(expanded);

    if (!expanded && clearValues) clearValues();
  }, [expanded]);

  return (
    <Off.Container id="offcanvas" $isOpen={isExpanded} onMouseDown={closeIfClickEmpty} $isModal={isModal}>
      <Off.Content
        $isOpen={isExpanded}
        $backgroundColor={backgroundColor}
        $width={width}
        $isModal={isModal}
        $typeAnimation={typeAnimation}
        className={id}
      >
        <Off.Header $isModal={isModal}>
          <div
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            <Off.ContainerTitleAndIcon>
              <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
                {titleIcon && <Off.TitleIcon>{titleIcon}</Off.TitleIcon>}
                <div style={{ minWidth: 0 }}>
                  <Off.Title $isModal={isModal} $colorTitle={colorTitle} $fontSizeTitle={fontSizeTitle}>
                    {title}
                  </Off.Title>

                  {subtitle && <Off.Subtitle>{subtitle}</Off.Subtitle>}
                </div>
              </div>

              <Off.Label
                onClick={handleClose}
                $sizeCloseText={sizeCloseText}
                $colorCloseText={colorCloseText}
              >
                <Off.CloseIcon $backgroundCloseIconColor={backgroundCloseIconColor}>
                  <IoClose
                    size={25}
                    color={colorCloseIcon || "#64748b"}
                  />
                </Off.CloseIcon>
              </Off.Label>
            </Off.ContainerTitleAndIcon>
          </div>

          {headerItem && (
            <div style={{ width: "100%", margin: "0.5rem 0" }}>
              {headerItem}
            </div>
          )}
        </Off.Header>

        <Off.Body $paddingBody={paddingBody} $isModal={isModal}>
          {children}
        </Off.Body>

        {footer && (
          <Off.Footer $isModal={isModal}>
            {footer}
          </Off.Footer>
        )}
      </Off.Content>
    </Off.Container>
  );
}
